import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

// 全局引用cookie方法类
const userInfo = JSON.parse(localStorage.getItem('userInfo')) || ''

const state = {
  userInfo,
}
export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js